var _style, _line, _line2, _path, _path2, _line3, _path3, _line4, _line5, _line6, _line7, _line8, _line9;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcon41(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icons",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 32 32",
    style: {
      enableBackground: "new 0 0 32 32"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:none;stroke:#000000;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\r\n")), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 16,
    y1: 9,
    x2: 16,
    y2: 10
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 16,
    y1: 16,
    x2: 16,
    y2: 17
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M17,10h-1.5c-0.8,0-1.5,0.7-1.5,1.5v0c0,0.8,0.7,1.5,1.5,1.5h1c0.8,0,1.5,0.7,1.5,1.5v0c0,0.8-0.7,1.5-1.5,1.5 H15"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M24,12c0-4.7-4.1-8.5-8.9-7.9c-3.5,0.4-6.4,3.2-7,6.7c-0.4,2.6,0.5,5.1,2.1,6.8c1.2,1.2,1.8,2.8,1.8,4.5v0h8v0 c0-1.6,0.6-3.3,1.7-4.4C23.1,16.1,24,14.2,24,12z"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 20,
    y1: 25,
    x2: 12,
    y2: 25
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M19,26c0,1.7-1.3,3-3,3s-3-1.3-3-3"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 4,
    y1: 13,
    x2: 2,
    y2: 13
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 7.5,
    y1: 21.5,
    x2: 6.1,
    y2: 22.9
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 24.5,
    y1: 21.5,
    x2: 25.9,
    y2: 22.9
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 28,
    y1: 13,
    x2: 30,
    y2: 13
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 24.5,
    y1: 4.5,
    x2: 25.9,
    y2: 3.1
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 7.5,
    y1: 4.5,
    x2: 6.1,
    y2: 3.1
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon41);
export default __webpack_public_path__ + "static/media/icon_41.39a3d4c8c6b7b5e3ea1c44fe01cbc079.svg";
export { ForwardRef as ReactComponent };